import { render, staticRenderFns } from "./StrainNotesTable.template.vue?vue&type=template&id=50eeccac&scoped=true&"
var script = {}
import style0 from "./StrainNotesTable.template.vue?vue&type=style&index=0&id=50eeccac&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50eeccac",
  null
  
)

export default component.exports